import { z } from 'zod';
import { recoveryIdentityBootstrapDescriptorV1Schema } from '../recovery/hardening/identityBootstrap';
import type { MaintenanceTask } from './maintenanceTypes';
export const maintenanceIdentityBootstrapSchema = z.object({ descriptor: recoveryIdentityBootstrapDescriptorV1Schema,
  authorityConfigurationBytes: z.string().min(4).max(87384).refine(value => {
    try { return /^[A-Za-z0-9+/]*={0,2}$/.test(value) && globalThis.btoa(globalThis.atob(value)) === value && globalThis.atob(value).length <= 65536; }
    catch { return false; }
  }) }).strict();
export function validateMaintenanceIdentityBootstrap(task: MaintenanceTask,context: z.RefinementCtx): void {
  const identity=task.operation==='bootstrap-identity',artifact=task.artifact;
  if (identity ? task.context.kind!=='machine-system' || task.policy.hostMode!=='any-mode' || task.reconcileArtifact!==null
    || artifact.kind!=='identity-bootstrap-only' || !artifact.identityBootstrap || artifact.targetVersion!==null
    || artifact.branch!==null || artifact.installerVersion!==undefined
    || artifact.identityBootstrap.descriptor.payload.installerSha256!==artifact.sha256
    || artifact.identityBootstrap.descriptor.payload.installerBytes!==String(artifact.byteLength)
    : artifact.kind==='identity-bootstrap-only' || artifact.identityBootstrap!==undefined)
    context.addIssue({ code:z.ZodIssueCode.custom,path:['artifact'],message:'Invalid identity-only bootstrap scope' });
  if(task.reconcileArtifact?.kind!==undefined || task.reconcileArtifact?.identityBootstrap!==undefined)
    context.addIssue({ code:z.ZodIssueCode.custom,path:['reconcileArtifact'],message:'Identity bootstrap cannot be a classifier' });
}
